import { gql } from "@apollo/client";

export const SUBMIT_BOOKING_ENQUIRY = gql`
  mutation submitBookingEnquiry($branchId: String!, $enquiry: BookingEnquiryInput!) {
    submitBookingEnquiry(branchId: $branchId, enquiry: $enquiry) {
      success
      message
    }
  }
`;
